var _circle, _circle2, _circle3, _g, _rect, _circle4, _g2, _rect2, _circle5, _circle6, _g3, _rect3, _circle7, _g4, _rect4, _circle8, _circle9, _g5, _rect5, _circle10, _g6, _rect6, _circle11, _circle12, _g7, _rect7, _circle13, _g8, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1026,
    height: 1040,
    viewBox: "0 0 1026 1040",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 64.8349,
    transform: "matrix(1 0 0 -1 252.354 256.165)",
    fill: "#C344FF",
    stroke: "#C344FF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 65.8349,
    transform: "matrix(1 0 0 -1 108.835 256.165)",
    fill: "#FF519A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 65.8349,
    transform: "matrix(1 0 0 -1 512.835 518.835)",
    fill: "#FF519A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 247.5,
    transform: "matrix(1 0 0 -1 264 260)",
    stroke: "#7858FB",
    strokeWidth: 3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 27,
    rx: 13.5,
    transform: "matrix(1 0 0 -1 195 513)",
    fill: "#7858FB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 65.8349,
    transform: "matrix(1 0 0 -1 418.835 247.165)",
    fill: "#FF9559"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 150,
    transform: "matrix(1 0 0 -1 181.5 256.5)",
    stroke: "#FF519A",
    strokeWidth: 3
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 27,
    rx: 13.5,
    transform: "matrix(1 0 0 -1 129 415)",
    fill: "#FF519A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 64.8349,
    transform: "matrix(-1 0 0 1 773.646 775.835)",
    fill: "#C344FF",
    stroke: "#C344FF",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 65.8349,
    transform: "matrix(-1 0 0 1 917.165 775.835)",
    fill: "#FF519A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 247.5,
    transform: "matrix(-1 0 0 1 762 772)",
    stroke: "#7858FB",
    strokeWidth: 3
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 27,
    rx: 13.5,
    transform: "matrix(-1 0 0 1 831 519)",
    fill: "#7858FB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 65.8349,
    transform: "matrix(-1 0 0 1 607.165 784.835)",
    fill: "#FF9559"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 150,
    transform: "matrix(-1 0 0 1 844.5 775.5)",
    stroke: "#FF519A",
    strokeWidth: 3
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 27,
    rx: 13.5,
    transform: "matrix(-1 0 0 1 897 617)",
    fill: "#FF519A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.354,
    cy: 775.835,
    r: 64.8349,
    fill: "#C344FF",
    stroke: "#C344FF",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.835,
    cy: 775.835,
    r: 65.8349,
    fill: "#FF519A"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 772,
    r: 247.5,
    stroke: "#7858FB",
    strokeWidth: 3
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 519,
    width: 138,
    height: 27,
    rx: 13.5,
    fill: "#7858FB"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.835,
    cy: 784.835,
    r: 65.8349,
    fill: "#FF9559"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 775.5,
    r: 150,
    stroke: "#FF519A",
    strokeWidth: 3
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 617,
    width: 105,
    height: 27,
    rx: 13.5,
    fill: "#FF519A"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.646,
    cy: 256.165,
    r: 64.8349,
    transform: "rotate(-180 773.646 256.165)",
    fill: "#C344FF",
    stroke: "#C344FF",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 917.165,
    cy: 256.165,
    r: 65.8349,
    transform: "rotate(-180 917.165 256.165)",
    fill: "#FF519A"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 260,
    r: 247.5,
    transform: "rotate(-180 762 260)",
    stroke: "#7858FB",
    strokeWidth: 3
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 831,
    y: 513,
    width: 138,
    height: 27,
    rx: 13.5,
    transform: "rotate(-180 831 513)",
    fill: "#7858FB"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.165,
    cy: 247.165,
    r: 65.8349,
    transform: "rotate(-180 607.165 247.165)",
    fill: "#FF9559"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 844.5,
    cy: 256.5,
    r: 150,
    transform: "rotate(-180 844.5 256.5)",
    stroke: "#FF519A",
    strokeWidth: 3
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 897,
    y: 415,
    width: 105,
    height: 27,
    rx: 13.5,
    transform: "rotate(-180 897 415)",
    fill: "#FF519A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 528,
    height: 528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 15,
    y: 94,
    width: 333,
    height: 333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 498,
    y: 512,
    width: 528,
    height: 528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 678,
    y: 613,
    width: 333,
    height: 333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 0,
    y: 512,
    width: 528,
    height: 528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 15,
    y: 613,
    width: 333,
    height: 333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 498,
    y: 0,
    width: 528,
    height: 528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 678,
    y: 94,
    width: 333,
    height: 333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.8eb807e39609c16d8ddc6cc02719f84e.svg";
export { ForwardRef as ReactComponent };